// extracted by mini-css-extract-plugin
export default {"constructor":"burger-constructor_constructor__LtCHO","isHover":"burger-constructor_isHover__wU9ol","order-submit":"burger-constructor_order-submit__oYpBF"};